import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'


export default function Create_Projects() {
  var trgtextarea = '';
  var def_proj_name = ''
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showProjectHelp, setShowProjectHelp] = useState(false);
  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    document.getElementById("pro_deadline").setAttribute("min", today);
    document.getElementById("pro_deadline").addEventListener("change", function () {
      const selectedDate = new Date(this.value);
      const currentDate = new Date();

      // Calculate the difference in milliseconds
      const difference = selectedDate - currentDate;

      // Convert milliseconds to days
      const daysDifference = Math.ceil(difference / (1000 * 60 * 60 * 24));

      document.getElementById("result_days").innerText = `Remaining Days: ${daysDifference} days`;
    });
    function getTodaysDate() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }
    $('#pro_deadline').val(getTodaysDate());
  }, [])



  async function sendQuery(specval, proid) {

    const requirementInput = specval;
    const btn = document.getElementById('generateBtn');

    if (!requirementInput) {
        console.log('Please enter a requirement description.');
        return;
    }

    if (!proid) {
        console.log('Project ID is missing.');
        return;
    }

    btn.disabled = true;
    btn.innerText = 'Analyzing your project...';

    try {

        const response = await fetch('get_help_api.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                requirement: requirementInput,
                project_id: proid
            })
        });

        const result = await response.json();

        if (response.ok && result.success) {

            console.log(result.data);
            console.log(result.message);
            document.getElementById('addfile').classList.remove('nodisplay')

        } else {

            console.error(
                optionAlert('We cannot generate your project details right now for some technical issue. You can generate it later from your project details page. We will request you to generate it as soon as the project publish.')
                
            );

        }

    } catch (err) {

        console.error('Network Error: ' + err.message);

    } finally {

        btn.disabled = false;
        btn.innerText = 'Generate Task Details';

    }
}

function optionAlert(msg){
   $('#optionalert').css('display', 'block');
    $('#optionalert_text').text(msg);
}

function closeOptionAlert(){
   document.getElementById('addfile').classList.remove('nodisplay');
   $('#optionalert').css('display', 'none');
}
  

  function create_your_project() {
    var company_id = localStorage.getItem('mem_company_id');
    let projname = $('#proname').val();
    var pro_details = $('#prodetails').val();
    const today = new Date().toLocaleDateString('en-CA');
    var dateOFentry = today;
    var deadline = $('#pro_deadline').val();


    if (projname === '') {
      showAlert('Please insert your project name')
    } else {
      const btn = document.getElementById('generateBtn');
      btn.disabled = true;
      btn.innerText = 'Saving your project...';
      var obj = {
        'project_name': projname,
        'project_spec': pro_details,
        'project_entry': dateOFentry,
        'project_end': deadline,
        'pr_company_id': company_id
      };
      $.ajax({
        type: 'POST',
        url: 'save_project.php',
        data: obj,
        cache: false,
        success: function (result) {
          if (result !== 'fail') {
            let proid = result ? result.trim() : '';
            localStorage.setItem('proname', projname);
            localStorage.setItem('current_project_id', proid);
            localStorage.setItem('current_project_deadline', deadline);
            //sendQuery(pro_details,proid)
            document.getElementById('addfile').classList.remove('nodisplay')
            //navigate('/manage_team');
          } else {
            alert('Cannot save your project. Please  try again');
          }
        },
      });
    }

  }
  function closeAddFilePOP() {
    document.getElementById('addfile').classList.add('nodisplay')
    navigate('/manage_team');
  }

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  } 

  const uploadfiles = async () => {
    const fileInput = document.getElementById("project_file");
    const files = fileInput.files;

    if (files.length === 0) {
      alert("Please select at least one file");
      return;
    }

    const formData = new FormData();

    // append multiple files
    for (let i = 0; i < files.length; i++) {
      formData.append("files[]", files[i]);
    }

    // extra data
    formData.append("pro_name", localStorage.getItem("proname"));
    formData.append("pro_id", localStorage.getItem("current_project_id"));

    formData.append(
      "description",
      "This file is for documented the project. Please read/view all files before start working on the project."
    );

    try {
      const res = await fetch("upload_files.php", {
        method: "POST",
        body: formData,
      });

      const result = await res.json();

      if (result.status === "success") {
        alert("Files uploaded successfully");
        navigate('/manage_team');
      } else {
        alert(result.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };


  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <section className='vl_dsh_bodypart_section'>
          <div className='create_heading pos_rel'>
            <h2>Create a new project<button type="button" className={`query_button ${showProjectHelp ? 'active' : ''}`} onClick={() => setShowProjectHelp(!showProjectHelp)} aria-label="Project creation help" >?</button></h2>
          </div>
          {showProjectHelp && (
            <div className='help_text_area'>
              <div className='help_title'>
                <i className="ri-information-line"></i>
                Before you begin
              </div>

              <div className='help_content'>
                <p>
                  Creating a project is a simple step-by-step process. Start by
                  entering the project name and then provide a short description
                  of the project.
                </p>

                <p>
                  <strong>Why add a project description?</strong><br />
                  A clear description helps Vilicus generate an initial task list
                  and technical overview. It also gives developers useful context
                  when working on project tasks.
                </p>

                <p>
                  <strong>Keep your client updated automatically.</strong><br />
                  You can add your client while creating the project. Once added,
                  the client will receive a secure link by email where they can
                  view their daily project updates. Updates are generated
                  automatically, so you don't need to send them manually.
                </p>

                <p>
                  After the project is created, it will appear in your project
                  list. From there, you can create, manage, and assign tasks
                  directly to your team.
                </p>
              </div>
            </div>
          )}

          <div className='vl_dsh_formnholder mt-50 bigheading'>
            <h2>Insert your project information</h2>
            <div className='formfieldcommon'>
              <label>Insert your project name**</label>
              <input type="text" id="proname" />
            </div>

            <div className='formfieldcommon'>
              <label>Enter your project details.**</label>

              <p>│ Describe the project in a few points. Vilicus will use
                │ this information to prepare your project workflow and
                │ initial todo list and also the  task explanation for developers.</p>
              <p className='pt-15'> Example:     <br></br>
                │ │ • E-commerce website for a clothing company  <br></br>
                │ │ • Customer can browse products and place orders <br></br>
                │ │ • Admin manages products and orders     <br></br>
                │ │ • Payment through Stripe  <br></br>
                │ │ • Deadline: 30 September                 </p>
              <textarea id="prodetails"></textarea>

            </div>
            <div className='formfieldcommon datecount'>
              <label>Insert your project deadline**</label>
              <input type="date" id="pro_deadline" on /><span id="result_days">Remaining days</span>
            </div>
            <div className='formfieldcommon'>
              <button onClick={create_your_project} id="generateBtn">Create Project</button>
            </div>
          </div>
        </section>
      </div>


      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>

      <div className='vl_dsh_popup' id="optionalert">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="optionalert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeOptionAlert}>Okay</button>
          </div>
        </div>
      </div>

      <div className='vl_dsh_popup z-9999' id="loader">
        <div className='loadertext'>Please wait, we are generating your project details.</div>
      </div>

      <div className='vl_dsh_popup_vis nodisplay' id="addfile">
        <div className='vl_dsh_pop_content'>
          <button className='vl_dsh_pop_content_close' onClick={closeAddFilePOP}>+</button>
          <h2 className='vl_dsh_pop_content_heading'>Upload Files</h2>
          <div className='upload_section'>

            <div className='formfieldholder'>
              <p>Upload your files here to access them later in the Files tab of the Project Details page. These files will be treated as project documentation. Supported formats: PDF, DOCX, PNG, JPG, GIF, ZIP, and RAR.</p>
            </div>
            <div className='uploaderholder'>

              <input type="file" id="project_file" className='uploader' multiple onChange={handleFileChange} />
              <div className='uploadcover'>Browse  or drag & drop files</div>
            </div>
            <div className="mt-15">
              {files.length > 0 ? (
                <ul>
                  {files.map((file, index) => (
                    <li key={index}>{file.name}</li>
                  ))}
                </ul>
              ) : (
                <p>No files selected.</p>
              )}
            </div>
            <div className='buttonholder mt-15'>
              <button onClick={uploadfiles}>Uplaod</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
